import { get, patch, post, httpDelete } from '../../utils/http';

export const fetchProjectFields = ({ accountId, branchId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/project-fields`);

export const addProjectField = ({ accountId, branchId, field }) =>
  post(`/accounts/${accountId}/branches/${branchId}/project-fields`, field);

export const updateProjectField = ({ accountId, branchId, fieldId, field }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/project-fields/${fieldId}`, field);

export const deleteProjectField = ({ accountId, branchId, fieldId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/project-fields/${fieldId}`);
